const GROWTH_MY_REACTIVATE_MEMBERSHIP = {
  EXPERIMENT_NAME: 'growth-reactivate-my-membership-1_0_1',
  CONTROL: 'control',
  VARIATION_ON: 'on',
  VARIATION_OFF: 'off',
  VARIATION_E: 'variantion_e', // this is a typo, should be 'variation_e' but we can't change it now
  VARIATION_F: 'variation_f',
  VARIATION_G: 'variation_g',
  VARIATION_H: 'variation_h',
  VARIATION_I: 'variation_i',
  VARIATION_J: 'variation_j',
  VARIATION_K: 'variation_k',
  FEATURE_FLAG: 'growth-reactivate-my-membership',
};

export { GROWTH_MY_REACTIVATE_MEMBERSHIP };
